import * as React from 'react'
import { useCurrentUrl } from '../hooks/use-current-url'
import { useIsLoggedInQuery } from 'auth/hooks'
import { sessionStore } from 'utils/storage'

const BEFORE_AUTH_COUNTER_STORAGE_KEY = 'cf-before-auth-navigation-counter'
const AFTER_AUTH_COUNTER_STORAGE_KEY = 'cf-after-auth-navigation-counter'
const LAST_PATHNAME_STORAGE_KEY = 'cf-last-pathname'

export function getNavigationCount(afterAuth: boolean | undefined = false) {
  return tryParseInt(
    sessionStore.getString(
      afterAuth ? AFTER_AUTH_COUNTER_STORAGE_KEY : BEFORE_AUTH_COUNTER_STORAGE_KEY,
    ),
  )
}

export function SessionNavigationCounter() {
  const currentUrl = useCurrentUrl()
  const currentPathname = currentUrl ? new URL(currentUrl).pathname : ''
  const { data: isLoggedIn, isPending } = useIsLoggedInQuery()

  React.useEffect(() => {
    if (
      currentPathname &&
      getLastPathname() !== currentPathname &&
      !isPending &&
      isLoggedIn !== undefined
    ) {
      incrementCounters(isLoggedIn)
      setLastPathname(currentPathname)
    }
  }, [currentPathname, isLoggedIn, isPending])

  // Workaround for increasing the after auth counter when the user first logs in
  React.useEffect(() => {
    if (isLoggedIn && getNavigationCount(true) === 0) {
      incrementAfterAuthCounter()
    }
  }, [isLoggedIn])

  return null
}

function incrementCounters(isAuthenticated: boolean) {
  sessionStore.setString(BEFORE_AUTH_COUNTER_STORAGE_KEY, (getNavigationCount() + 1).toString())
  if (isAuthenticated) {
    incrementAfterAuthCounter()
  }
}

function incrementAfterAuthCounter() {
  sessionStore.setString(AFTER_AUTH_COUNTER_STORAGE_KEY, (getNavigationCount(true) + 1).toString())
}

function tryParseInt(value: string | null) {
  if (!value) {
    return 0
  }
  // oxlint-disable-next-line radix
  const parsed = parseInt(value)
  return isNaN(parsed) ? 0 : parsed
}

function getLastPathname() {
  return sessionStore.getString(LAST_PATHNAME_STORAGE_KEY)
}

function setLastPathname(pathname: string) {
  sessionStore.setString(LAST_PATHNAME_STORAGE_KEY, pathname)
}
